import $ from 'jquery';

function OffcanvasCtrl(target) {
	this.$target = $(target)
}

OffcanvasCtrl.prototype.init = function () {
	this.$target.on('click', this.click);
}

OffcanvasCtrl.prototype.click = function () {
	const self = $(this);
	const rowOffcanvas = $('.row-offcanvas');

	rowOffcanvas.toggleClass('active');
	if (rowOffcanvas.hasClass('active')) {
		$('<div/>', {
			'class': 'offcanvas-blank',
			'data-toggle': 'offcanvas',
			css: {
				opacity: 0
			},
			click: function() {
				rowOffcanvas.removeClass('active');
				$(this).animate({
					opacity: 0
				}, 250, function() {
					$(this).remove();
				});
			}
		}).appendTo('body').animate({
			opacity: 1
		}, 250);
	} else {
		$('.offcanvas-blank').animate({
			opacity: 0
		}, 250, function() {
			$(this).remove();
		});
	}
}

export default OffcanvasCtrl;